// @flow
import EmployeesAtWork from './EmployeesAtWork';

export default EmployeesAtWork;
